import React, { useEffect, useState } from "react";
import { useAuth } from "@/auth/AuthContext";
import { api } from "@/lib/api";
import TaskCard from "@/components/TaskCard";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function MyTasks() {
  const { user } = useAuth();
  const [tasks, setTasks] = useState([]);
  const [depts, setDepts] = useState({});

  useEffect(() => {
    (async () => {
      const [tasksRes, deptsRes] = await Promise.all([
        api.get("/tasks?limit=200"),
        api.get("/departments"),
      ]);
      setTasks(tasksRes.data);
      setDepts(Object.fromEntries(deptsRes.data.map((d) => [d.dept_id, d.name])));
    })();
  }, []);

  const owned = tasks.filter((t) => t.owner_id === user.user_id);
  const working = tasks.filter((t) => (t.assignee_ids || []).includes(user.user_id));

  return (
    <div className="p-4 md:p-6 lg:p-8 max-w-7xl mx-auto" data-testid="my-tasks-page">
      <div className="mb-6">
        <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">My work</div>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-bold mt-1">Tasks I'm involved in</h1>
      </div>

      <Tabs defaultValue="working" className="w-full">
        <TabsList className="rounded-sm">
          <TabsTrigger value="working" data-testid="tab-working">Working on ({working.length})</TabsTrigger>
          <TabsTrigger value="owned" data-testid="tab-owned">I posted ({owned.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="working" className="pt-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
            {working.map((t) => <TaskCard key={t.task_id} task={t} departmentName={depts[t.department_id]} />)}
            {working.length === 0 && <div className="col-span-full text-sm text-zinc-500 p-8 border border-dashed border-border" data-testid="working-empty">You're not assigned to any tasks yet. Visit the marketplace to apply.</div>}
          </div>
        </TabsContent>
        <TabsContent value="owned" className="pt-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
            {owned.map((t) => <TaskCard key={t.task_id} task={t} departmentName={depts[t.department_id]} />)}
            {owned.length === 0 && <div className="col-span-full text-sm text-zinc-500 p-8 border border-dashed border-border" data-testid="owned-empty">You haven't posted any tasks yet.</div>}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
